import React from 'react';
import { getAppContext } from '~/lib/AppContext';

export default function DomainPurchaseNotices() {
    return (
        <>
            <p>
                <strong>
                    Your name, email, phone number and address will be disclosed to domain registrars for publication in
                    accordance with domain registration requirements.
                </strong>
            </p>
            {getAppContext().customer.item?.tax_code.type === 'scalar' && (
                <p className="mt-2 mb-2">
                    * All displayed prices are in AUD and are exclusive of{' '}
                    {getAppContext().customer.item?.tax_code.name}
                </p>
            )}
        </>
    );
}
